import React, { Component } from 'react';
import Grid from "@mui/material/Grid";
import MessageCard from '../../components/Cards/MessageCard.js';
import NumberInput from '../../components/TextFields/NumberInput.js';
import Button from '../../components/Button.js';
import Text from '../../components/Text.js';
import StepCompletionNotif from '../../components/Modals/StepCompletionNotif.js';
import Loader from '../../components/Loader.js';
import Modal from '../../components/Modals/Modal.js';
import DateInput from '../../components/TextFields/DateInput.js';
import * as dates from "@simplybenefits/sb-dates";
import * as Services from '../../services/index.js';
import colors from '../../theme/colors.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class CommissionsForm extends Component {
  state = {
    life: 0,
    add: 0,
    ltd: 0,
    std: 0,
    depLife: 0,
    ci: 0,
    dental: 0,
    health: 0,
    outOfCountry: 0,
    stopLoss: 0,
    hsa: 0,
    lsa: 0,
    efap: 0,
    virtualHealthcare: 0,
    financialAwareness: 0,
    setForAll: 0,
    successDialogOpen: false,
    effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
    showEffectiveDateDialog: false
  };
  async componentDidMount() {
    const commissions = await this.props.getCommissions(this.props.currentAccountMeta.accountID);
    if (commissions) {
      this.setState({
        ...commissions
      });
    }
  }
  _validateEffectiveDate = async () => {
    let effectiveDateError = await Services.validateInput('effectiveDate', this.state.effectiveDate);
    const startOfMonth = dates.getStartOfMonth();
    const effectiveDateUTC = dates.getUTC(this.state.effectiveDate);
    if (effectiveDateUTC < startOfMonth) {
      effectiveDateError = i18n.t(tokens.labels.advisor.commissionsCanOnlyBeBackdated);
    }
    await this.setState({
      effectiveDateError
    });
    if (effectiveDateError) {
      return false;
    }
    return true;
  };
  _handleChange = (key, value) => {
    this.setState({
      [key]: value
    });
  };
  _setGlobal = value => {
    this.setState({
      setForAll: value,
      life: value,
      add: value,
      ltd: value,
      std: value,
      depLife: value,
      ci: value,
      dental: value,
      health: value,
      outOfCountry: value,
      stopLoss: value,
      hsa: value,
      lsa: value,
      efap: value,
      virtualHealthcare: value,
      financialAwareness: value
    });
  };
  _toggleEffectiveDateDialog = () => {
    this.setState({
      showEffectiveDateDialog: !this.state.showEffectiveDateDialog
    });
  };
  _save = async () => {
    if (!this.props.isMasterSite && this.props.currentAccountMeta.state > 3) {
      return null;
    }
    const effectiveDateValid = await this._validateEffectiveDate();
    if (!effectiveDateValid) {
      return null;
    }
    const effectiveDate = dates.getUTC(this.state.effectiveDate);
    const data = {
      ...this.state
    };
    delete data.effectiveDate;
    delete data.setForAll;
    delete data.successDialogOpen;
    delete data.showEffectiveDateDialog;
    delete data.effectiveDateError;
    const success = await this.props.saveCommissions(this.props.currentAccountMeta.accountID, data, effectiveDate);
    if (success) {
      this.setState({
        effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
        showEffectiveDateDialog: false
      });
    }
    return null;
  };

  // eslint-disable-next-line consistent-return
  _submit = async () => {
    const data = {
      ...this.state
    };
    delete data.setForAll;
    delete data.successDialogOpen;
    delete data.effectiveDate;
    delete data.showEffectiveDateDialog;
    delete data.effectiveDateError;
    const success = await this.props.submitCommissions(this.props.currentAccountMeta.accountID, data);
    if (success && this.props.isRevision) {
      this.props.setSelectedSection("revision-plan-pricing");
      return null;
    }
    if (success) {
      this.setState({
        successDialogOpen: true
      });
    }
  };
  _closeSuccessDialog = () => {
    this.setState({
      successDialogOpen: false
    });
  };
  _goToNextStep = () => {
    // refresh the page to get the latest changes and move back to dashboard
    window.location.reload();
  };
  render() {
    const styles = {
      contentBlock: {
        backgroundColor: colors.surface,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        display: 'block',
        margin: 'auto auto 30px auto',
        padding: '30px',
        position: 'relative',
        zIndex: 3
      }
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, !this.props.isMasterSite && this.props.currentAccountMeta.status === 1 && !this.props.isRevision ? /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.commissionsBreakdown),
      subtitle: i18n.t(tokens.labels.advisor.viewCommissionsInstructions),
      btn: false
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, !this.props.isMasterSite && this.props.currentAccountMeta.state > 3 && /*#__PURE__*/React.createElement(Text, {
      color: "red"
    }, i18n.t(tokens.labels.advisor.commissionsChangeNotice)), this.props.isMasterSite && !this.props.isQuote && !this.props.isRevision ? /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.commissionAssignment),
      subtitle: i18n.t(tokens.labels.advisor.setCommissionRatesInstructions)
    }) : /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.commissionAssignment),
      subtitle: i18n.t(tokens.labels.advisor.finalizeCommissionRatesInstructions),
      btn: this.props.isQuote && this.props.currentAccountMeta.state <= 1 || this.props.isRevision && this.props.step <= 1,
      btnName: i18n.t(tokens.buttons.submit),
      btnOnClick: this._submit
    })), /*#__PURE__*/React.createElement("div", {
      style: styles.contentBlock
    }, /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      display: "block"
    }, i18n.t(tokens.labels.advisor.setAll), ":"), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sx: {
        width: '24.5%',
        minWidth: 200
      }
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.commissions),
      fullWidth: true,
      suffix: "%",
      value: this.state.setForAll || 0,
      onChange: e => this._setGlobal(e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      display: "block",
      margin: "20px 0 0 0"
    }, i18n.t(tokens.labels.advisor.setIndividually), ":"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.lifeInsurance),
      fullWidth: true,
      suffix: "%",
      value: this.state.life || 0,
      onChange: e => this._handleChange("life", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.accidentalDeathAndDismemberment),
      fullWidth: true,
      suffix: "%",
      value: this.state.add || 0,
      onChange: e => this._handleChange("add", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.longTermDisability),
      fullWidth: true,
      suffix: "%",
      value: this.state.ltd || 0,
      onChange: e => this._handleChange("ltd", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.shortTermDisability),
      fullWidth: true,
      suffix: "%",
      value: this.state.std || 0,
      onChange: e => this._handleChange("std", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.dependentLife),
      fullWidth: true,
      suffix: "%",
      value: this.state.depLife || 0,
      onChange: e => this._handleChange("depLife", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.criticalIllness),
      fullWidth: true,
      suffix: "%",
      value: this.state.ci || 0,
      onChange: e => this._handleChange("ci", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.dental),
      fullWidth: true,
      suffix: "%",
      value: this.state.dental || 0,
      onChange: e => this._handleChange("dental", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.health),
      fullWidth: true,
      suffix: "%",
      value: this.state.health || 0,
      onChange: e => this._handleChange("health", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.outOfCountry),
      fullWidth: true,
      suffix: "%",
      value: this.state.outOfCountry || 0,
      onChange: e => this._handleChange("outOfCountry", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.stopLoss),
      fullWidth: true,
      suffix: "%",
      value: this.state.stopLoss || 0,
      onChange: e => this._handleChange("stopLoss", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.healthSpending),
      fullWidth: true,
      suffix: "%",
      value: this.state.hsa || 0,
      onChange: e => this._handleChange("hsa", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.lifestyleSpending),
      fullWidth: true,
      suffix: "%",
      value: this.state.lsa || 0,
      onChange: e => this._handleChange("lsa", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.employeeAssistance),
      fullWidth: true,
      suffix: "%",
      value: this.state.efap || 0,
      onChange: e => this._handleChange("efap", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.virtualHealthCare),
      fullWidth: true,
      suffix: "%",
      value: this.state.virtualHealthcare || 0,
      onChange: e => this._handleChange("virtualHealthcare", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.financialAwareness),
      fullWidth: true,
      suffix: "%",
      value: this.state.financialAwareness || 0,
      onChange: e => this._handleChange("financialAwareness", e.target.value),
      variant: "outlined"
    }))), (this.props.isMasterSite || this.props.currentAccountMeta.state <= 3) && /*#__PURE__*/React.createElement(Button, {
      onClick: () => {
        if (!this.props.isQuote && !this.props.isRevision && this.props.isMasterSite) {
          this._toggleEffectiveDateDialog();
        } else {
          this._save();
        }
      },
      color: "primary",
      customStyle: {
        display: 'block',
        marginLeft: 'auto'
      }
    }, i18n.t(tokens.buttons.saveCommissions))), /*#__PURE__*/React.createElement(StepCompletionNotif, {
      dialog: i18n.t(tokens.labels.advisor.successfulSubmissionMessage),
      type: "Commissions",
      open: this.state.successDialogOpen,
      handleClose: this._closeSuccessDialog,
      handleNext: this._goToNextStep,
      disableBackdropClick: true,
      disableEscapeKeyDown: true
    }), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showEffectiveDateDialog,
      onClose: this._toggleEffectiveDateDialog,
      title: i18n.t(tokens.titles.setEffectiveDate),
      primaryButton: {
        label: i18n.t(tokens.buttons.submit),
        onClick: this._save
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.pleaseProvideEffectiveDate)), /*#__PURE__*/React.createElement(DateInput, {
      label: i18n.t(tokens.labels.effectiveDate),
      value: this.state.effectiveDate,
      onChange: e => {
        this.setState({
          effectiveDate: e.target.value
        });
      },
      error: Boolean(this.state.effectiveDateError),
      helperText: this.state.effectiveDateError,
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.changesAppliedOnEffectiveDate))), this.props.loader?.isLoading && this.props.loader.type === 'container' && /*#__PURE__*/React.createElement(Loader, {
      isContainer: true
    }));
  }
}
export default CommissionsForm;